import React from 'react';
import ArrowProfile from '../icons/ArrowProfile.png';

const CustomButton = ({ label, onClick, type = "default", disabled = false, style }) => {
  const getButtonStyle = () => {
    switch (type) {
      case "primary":
        return { backgroundColor: 'var(--primary-white-color)', color: 'var(--primary-color)' };
      case "secondary":
        return { backgroundColor: 'var(--primary-color)', color: 'var(--primary-white-color)', fontSize: "16px" };
      case "danger":
        return { backgroundColor: "#f44336", color: "#fff" };
        case "response":
          return { backgroundColor: 'var(--primary-white-color)', color: 'var(--primary-color)', fontSize: "24px", };
          case "next":
            return { backgroundColor: 'var(--primary-color)', color: 'var(--primary-white-color)' };
          case "back":
            return { backgroundColor: 'var(--primary-color)', color: 'var(--primary-white-color)' };
      case "default":
      default:
        return { backgroundColor: "#e0e0e0", color: "#000" };
    }
  };

  return (
    <>
      <button
        onClick={onClick}
        disabled={disabled}
        style={{ 
          padding: "10px 50px",
          border: "none",
          borderRadius: "20px",
          fontSize: "35px",
          cursor: "pointer",
          ...getButtonStyle(),
          ...style // Custom styles passed as props
        }}
      >
        {type === "next" ? <img src={ArrowProfile} alt="Next" style={{ width: '48px', height: '30px' }} /> : type === "back" ? <img src={ArrowProfile} alt="Back" style={{ width: '48px', height: '30px', transform: 'rotate(180deg)' }} /> : label}
      </button>
      {type === "next" || type === "back" ? (
        <div style={{ textAlign: 'center', fontSize: '24px' }}>
          {label}
        </div>
      ) : null}
    </>
  );
};

export default CustomButton;
